export const hours = [
  {
    displayName: '12 am',
    displayValue: '12',
    value: 0,
  },
  {
    displayName: '1 am',
    displayValue: '1',
    value: 1,
  },
  {
    displayName: '2 am',
    displayValue: '2',
    value: 2,
  },
  {
    displayName: '3 am',
    displayValue: '3',
    value: 3,
  },
  {
    displayName: '4 am',
    displayValue: '4',
    value: 4,
  },
  {
    displayName: '5 am',
    displayValue: '5',
    value: 5,
  },
  {
    displayName: '6 am',
    displayValue: '6',
    value: 6,
  },
  {
    displayName: '7 am',
    displayValue: '7',
    value: 7,
  },
  {
    displayName: '8 am',
    displayValue: '8',
    value: 8,
  },
  {
    displayName: '9 am',
    displayValue: '9',
    value: 9,
  },
  {
    displayName: '10 am',
    displayValue: '10',
    value: 10,
  },
  {
    displayName: '11 am',
    displayValue: '11',
    value: 11,
  },
  {
    displayName: '12 pm',
    displayValue: '12',
    value: 12,
  },
  {
    displayName: '1 pm',
    displayValue: '1',
    value: 13,
  },
  {
    displayName: '2 pm',
    displayValue: '2',
    value: 14,
  },
  {
    displayName: '3 pm',
    displayValue: '3',
    value: 15,
  },
  {
    displayName: '4 pm',
    displayValue: '4',
    value: 16,
  },
  {
    displayName: '5 pm',
    displayValue: '5',
    value: 17,
  },
  {
    displayName: '6 pm',
    displayValue: '6',
    value: 18,
  },
  {
    displayName: '7 pm',
    displayValue: '7',
    value: 19,
  },
  {
    displayName: '8 pm',
    displayValue: '8',
    value: 20,
  },
  {
    displayName: '9 pm',
    displayValue: '9',
    value: 21,
  },
  {
    displayName: '10 pm',
    displayValue: '10',
    value: 22,
  },
  {
    displayName: '11 pm',
    displayValue: '11',
    value: 23,
  },
];
